import { render } from "./DiasCreditoList.vue?vue&type=template&id=651c7e46&scoped=true"
import script from "./DiasCreditoList.vue?vue&type=script&lang=js"
export * from "./DiasCreditoList.vue?vue&type=script&lang=js"

import "./DiasCreditoList.vue?vue&type=style&index=0&id=651c7e46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651c7e46"]])

export default __exports__